const BoardDocPromotionsAdapter = data => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const prepareData = (i) => ({
    ...i,
    'promotion_translations.title': i?.title,
    'company.title': i.company?.title,
    'shopping_centers.title': i.shopping_center_title,
  });

  if (Array.isArray(data)) {
    data.forEach(i => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};

export default BoardDocPromotionsAdapter;
